function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { AnimatePresence, motion, useMotionValueEvent, useScroll } from "framer-motion";
import React, { useState } from "react";
import { ArrowUpIcon } from "../Molecules/icons";
export var ScrollToTopButton = function() {
    var _useState = _sliced_to_array(useState(false), 2), isVisible = _useState[0], setIsVisible = _useState[1];
    var scrollY = useScroll().scrollY;
    useMotionValueEvent(scrollY, "change", function(latest) {
        setIsVisible(latest > window.innerHeight);
    });
    var onClick = function() {
        window.scrollTo({
            top: 0
        });
    };
    return /*#__PURE__*/ React.createElement(AnimatePresence, null, isVisible && /*#__PURE__*/ React.createElement(motion.button, {
        "aria-label": "Back to top",
        className: "flex flex-col items-center uppercase text-green-500 gap-2 text-sm font-semibold leading-sm fixed right-6 md:right-10 bottom-6 md:bottom-10 focus-dark",
        initial: {
            opacity: 0,
            y: 30
        },
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.2,
                type: "spring",
                damping: 10,
                stiffness: 100
            }
        },
        exit: {
            opacity: 0,
            y: 30,
            transition: {
                duration: 0.2,
                type: "easeOut"
            }
        }
    }, /*#__PURE__*/ React.createElement("div", {
        key: "scroll-to-top-button",
        className: "rounded-full py-3 px-[0.5rem] md:py-4 md:px-3 bg-green-500",
        onClick: onClick
    }, /*#__PURE__*/ React.createElement(ArrowUpIcon, {
        "aria-hidden": "true"
    })), /*#__PURE__*/ React.createElement("span", {
        "aria-hidden": "true",
        className: "hidden md:block "
    }, "Back to top")));
};
